



















































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import vuetifyToast from 'vuetify-toast';
import { Passenger } from '@/components/Passenger/models/Passenger';
import DateTimePicker from '@/components/DatetimePicker.vue';
import Destination from '@/components/Passenger/models/Destination';
import PassengerTripList from '@/components/Passenger/components/PassengerTripList.vue';
import Routes from '../Routes';
import PassengerDestination from '../components/Passenger/models/PassengerDestination';
import TransportationPermission from '../components/Passenger/models/TransportationPermission';
import { RolePermission } from '../models/Role';
import TransportationPermissionList from '@/components/Passenger/components/TransportationPermissionList.vue';
import TransportationPermissionEditor from '@/components/Passenger/components/TransportationPermissionEditor.vue';
import PassengerDetailsEditor from '@/components/Passenger/components/PassengerDetailsEditor.vue';
import PassengerUtilities from '@/components/Passenger/components/PassengerUtilities.vue';
import { PermissionEnum } from '../models/DestinationRole';
import MovitInstanceConfig from '@/models/MovitInstanceConfig';
import PassengerDestinationPicker from '@/components/Passenger/components/PassengerDestinationPicker.vue'
import SecondaryDestinationPicker from '@/components/Passenger/components/SecondaryDestinationPicker.vue'
import Schedules from '@/components/Schedule/Schedules.vue';
import restService from '@/services/restService';
import { PassengerGroup } from '@/models/PassengerGroup';

@Component({
  components: {
    // GroupPicker,
    DateTimePicker,
    PassengerTripList,
    PassengerUtilities,
    PassengerDetailsEditor,
    TransportationPermissionList,
    TransportationPermissionEditor,
    PassengerDestinationPicker,
    SecondaryDestinationPicker,
    Schedules,
  }
})
export default class PassengerPage extends Vue {

  public static NEW_GROUP_CREATOR_ITEM: string = "- New group -";

  permissionEnum = PermissionEnum;

  editedPassenger: Passenger = new Passenger(null);
  editedTransportationPermission: TransportationPermission | null = null;
  passengerPassengerGroups: PassengerGroup[] = []; 
  valid: boolean = true;
  saving: boolean = false;
  hasDestination: boolean = false;
  rules: any = {
    required: value => !!value 
      || this.$i18n.translate("validation.rules.required", "Required")
  }    
  inactivating: boolean = false;
  deleting: boolean = false;

  async created(){
    if (this.routePassengerId){
      await this.$store.dispatch("passenger/getPassengerById", {params: {id: this.routePassengerId}}); 
    }
    if (this.isCreating && this.selectedDestination.organizationId) {
      this.editedPassenger.organizationId = this.selectedDestination.organizationId;
      this.editedPassenger.transportationPermissionRequired = this.$store.getters['organization/organizationRequirePtpByDefault'](this.editedPassenger.organizationId);
    }
  }

  get isTransportationPermissionEnabled(): boolean {
    // #6364 hide PTP list while creating passenger.
    if (this.isCreating) {
      return false;
    }

    return this.$store.getters['auth/hasTransportationPermission']([RolePermission.ReadTransportationPermissions]);
  }

  get routeMeta() {
    return this.$route.meta;
  }

  @Watch("$store.state.passenger.error.createTransportationPermission")
  onCreateTransportationPermissionErrorChanged(val){
    if (val){
      vuetifyToast.error(this.$store.state.passenger.error.createTransportationPermission);
    }
  }

  @Watch("$store.state.passenger.error.updateTransportationPermission")
  onUpdateTransportationPermissionErrorChanged(val){
    if (val){
      vuetifyToast.error(this.$store.state.passenger.error.updateTransportationPermission);
    }
  }

  @Watch("$store.state.passenger.error.deleteTransportationPermission")
  onDeleteTransportationPermissionErrorChanged(val){
    if (val){
      vuetifyToast.error(this.$store.state.passenger.error.deleteTransportationPermission);
    }
  }

  get isEditing(): boolean {
    return this.$route.name === Routes.editPassengerRoute.name || this.$route.name === Routes.editPeopleRoute.name;
  }

  get isCreating(): boolean {
    return this.$route.name === Routes.newPassengerRoute.name 
    || this.$route.name === Routes.newOrganizationPassenger.name;
  }

  get userCanReadTransportationPermissions(): boolean {
    return this.$store.getters['auth/hasTransportationPermission']([RolePermission.ReadTransportationPermissions]);
  }

  get userCanEditTransportationPermissions(): boolean {
    return this.$store.getters['auth/hasTransportationPermission']([RolePermission.UpdateTransportationPermissions])
  }
  
  get userCanReadSchedules() {
    let passengerGroupIds = [];
    if (this.passengerPassengerGroups.length > 0) {
      passengerGroupIds = this.passengerPassengerGroups.map(g => g.id);
    }
    const canRead = this.$store.getters['auth/hasSchedulePermission'](PermissionEnum.Read, passengerGroupIds);
    return canRead;
  }

  get userCanEditSchedules() {
    let passengerGroupIds = [];
    if (this.passengerPassengerGroups.length > 0) {
      passengerGroupIds = this.passengerPassengerGroups.map(g => g.id);
    }
    return this.$store.getters['auth/hasSchedulePermission'](PermissionEnum.Write, passengerGroupIds);
  }

  get storeMovitInstanceConfigs(): MovitInstanceConfig[]{
    return this.$store.state.app.movitInstanceConfigs as MovitInstanceConfig[];
  }

  get destinationMovitInstanceConfig(): MovitInstanceConfig | undefined {
    if (this.selectedDestination) {
      return this.storeMovitInstanceConfigs.find(mic => mic.instanceId === this.selectedDestination.movitInstanceId);
    }
    return this.storeMovitInstanceConfigs[0];
  }

  get allowUserInput(): boolean {
    const canEdit = this.$store.getters['auth/hasPassengerPermission']([RolePermission.UpdatePassengers]);
    const canCreate =  this.$store.getters['auth/hasPassengerPermission']([RolePermission.CreatePassengers]);

    return (this.isEditing && canEdit) 
      || (this.isCreating && canCreate);
  }

  get isLoading(): boolean {
    return this.$store.state.passenger.pending.passenger || 
      this.$store.state.destination.pending.destinations;
  }

  get routeDestinationId(): number {
    return parseInt(this.$store.state.route.params.destinationId, 10);
  }

  get selectedDestinationId(): number {
    return this.routeDestinationId;
  }

  get selectedDestination(): Destination | null {
    const destination = this.destinations.find(d => d.id === this.routeDestinationId);
    return destination
      ? destination
      : null;
  }
  
  get destinations(): Destination[] {
    return this.$store.state.destination.destinations;
  }

  get routePassengerId(): number{
    return parseInt(this.$route.params.passengerId, 10);
  }

  get routePassenger(): Passenger | null {
      const passenger: Passenger = this.$store.state.passenger.passenger;
      if (passenger) {
        this.hasDestination = passenger.destinationIds && passenger.destinationIds.length > 0;
      }
      return passenger
        ? passenger
        : null;
  }
  get routePassenGerGroupIds() {
    if (this.$route.params.passengerGroupId) {
      return [this.$route.params.passengerGroupId]
      // .split(',').map(id => parseInt(id, 10));
    }
  }

  @Watch("routePassenger", {immediate: true})
  async onRoutePassengerChanged(val, oldVal){
    if (val){
      // this.verifyRoutePassengerHasRouteDestinationId();
      await this.initializePassengerEdit();
    } else {
      this.editedPassenger = new Passenger(
        {
          passengerDestinations: [
            new PassengerDestination(0, this.selectedDestinationId)
          ]
        }
      );
    }
  }

  get showTransportationPermissionEditor() {
    return this.editedTransportationPermission ? true : false;
  }

  get mainDestination() {
    return this.editedPassenger.passengerDestinations.find(x => x);
  }

  setDestinationValues(passengerDestination: PassengerDestination) {

    const selectedDestination = this.destinations.find(d => d.id === passengerDestination.destinationId);

    if (selectedDestination) {
      this.editedPassenger.movitInstanceId = selectedDestination.movitInstanceId;
      this.editedPassenger.destinationIds = this.editedPassenger.passengerDestinations.map(d => d.destinationId);
    }

  }

  async initializePassengerEdit() {      
    
    this.editedPassenger = Passenger.CopyFrom(this.routePassenger);
    await this.getPassengerPassengerGroups();
    if (this.isTransportationPermissionEnabled) {
      await this.getPassengerTransportationPermissionInfo();
    }
  }

  async getPassengerPassengerGroups() {
    const groups = await restService.passengers.getPassengerPassengerGroups(this.editedPassenger.id)
    this.passengerPassengerGroups = groups.map(g => {
      const group = PassengerGroup.fromApi(g);
      return group;
    })
  }

  async getPassengerTransportationPermissionInfo(){  
    await this.$store.dispatch(
        "passenger/getPassengerTransportationPermissionInfo", 
        { 
          params: { 
            passengerId: this.editedPassenger.id 
          }
      }
    );
  }

  async onDeleteClick() {
    this.deleting = true;
    if (
      confirm(
        this.$i18n.translate(
          'passenger.delete.confirm_with_name', 
          'Are you sure you want to delete {passengerName}?', 
          { 
            passengerName: this.editedPassenger.name
          } 
        )
      )
    ) {
      try {
        await this.$store.dispatch('passenger/deleteRequest', { params: { id: this.editedPassenger.id }});
      } catch (err){
        vuetifyToast.error(
          this.$i18n.translate(
            'passenger.delete.error.generic', 
            'There was an error when deleting the passenger. Please try again later.'
          )
        )
      }
    }
    this.deleting = false;
  };

  async onActivateClick() {
    this.saving = true;
    try {
      await this.$store.dispatch('passenger/activate', { params: { id: this.editedPassenger.id }});
      await this.initializePassengerEdit();
    } catch (err){
      vuetifyToast.error(
        this.$i18n.translate(
          'passenger.activate.error.generic', 
          'There was an error when activating the passenger. Please try again later.'
        )
      )
    }
    this.saving = false;
  }

  async onDeactivateClick() {
    this.saving = true;
    if (
      confirm(
        this.$i18n.translate('passenger.deactivate.confirm_with_name', 
          'Are you sure you want to deactivate {passengerName}?', 
          { 
            passengerName: this.editedPassenger.name
          } 
        )
      )
    ) {
      try {
        await this.$store.dispatch('passenger/deactivate', { params: { id: this.editedPassenger.id }});
        await this.initializePassengerEdit();
      } catch (err){
        vuetifyToast.error(
          this.$i18n.translate(
            'passenger.deactivate.error.generic', 
            'There was an error when deactivating the passenger. Please try again later.'
          )
        )
      }
    }
    this.saving = false;
  }

  async onSaveClick() {
      this.saving = true;
      // TODO: Get rid of casting to any
      if ((this.$refs.form as any).validate()) {
        try {
            if (this.editedPassenger.id > 0) {
            // console.log("save, update existing: ", this.editedPassenger);

              await (this.$refs.passengerEditor as any).saveSsn();
              await this.$store.dispatch('passenger/updatePassenger', 
                  { params: { id: this.editedPassenger.id}, data: this.editedPassenger });
              
              // Watching routePassenger will trigger initialization when the save finishes
              //await this.initializePassengerEdit();
                
            } else {
                (this.editedPassenger as any).destinationIds = this.editedPassenger
                    .passengerDestinations.map(pd => pd.destinationId);
                const ssn = (this.$refs.passengerEditor as any).getNewPassengerSsn();
                const result = await this.$store.dispatch('passenger/createPassenger', { data: this.editedPassenger });
                await (this.$refs.passengerEditor as any).saveSsnForNewPassenger(result.data.id, ssn);
                this.$router.replace({
                  name: Routes.editPeopleRoute.name,
                  params: {
                    passengerId: result.data.id,
                    destinationId: this.mainDestination.destinationId + '',
                  },
                });
            }
            vuetifyToast.success(this.$i18n.translate('passenger.save.success', 'Passenger saved successfully.'));
        } catch (err) {
            vuetifyToast.error(this.$i18n.translate('passenger.save.error.generic', 
                'There was an error saving the passenger. Please try again later.'));
            console.error("Error when saving passenger:", err);
        }
      }
      this.saving = false;
  }

  onBackToListClick() {
    if (this.editedPassenger.destinationIds && this.editedPassenger.destinationIds.length > 0) {
      this.$router.push({
        name: Routes.peopleRoute.name,
        params: { destinationId: this.editedPassenger.destinationIds[0].toString(),
        }
      })
    } else {
      this.$router.back();
    }
  }
}
